(() => {
  if (window.vicsMegaNavigation) return;
  const initialise = () => {
    document.querySelectorAll('[data-vics-navigation]').forEach((root) => {
      if (root.dataset.vicsReady === 'true') return;
      root.dataset.vicsReady = 'true';
      const items = [...root.querySelectorAll('.vics-navigation__details')];
      const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
      const updateHeight = () => {
        const available = Math.max(180, innerHeight - root.getBoundingClientRect().bottom);
        root.style.setProperty('--vics-menu-available', `${available}px`);
      };
      const close = (item) => {
        item.open = false;
        item.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      };
      items.forEach((item) => {
        const summary = item.querySelector('summary');
        summary.setAttribute('aria-expanded', 'false');
        let closeTimer;
        item.addEventListener('pointerenter', () => {
          if (!finePointer.matches) return;
          clearTimeout(closeTimer);
          items.forEach((other) => { if (other !== item) close(other); });
          updateHeight();
          item.open = true;
        });
        item.addEventListener('pointerleave', () => {
          if (finePointer.matches) closeTimer = setTimeout(() => close(item), 160);
        });
        item.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(item.open));
          if (!item.open) return;
          updateHeight();
          items.forEach((other) => { if (other !== item) close(other); });
        });
        item.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          event.preventDefault();
          close(item);
          summary.focus();
        });
        item.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !item.contains(event.relatedTarget)) close(item);
        });
      });
      document.addEventListener('click', (event) => {
        if (!root.isConnected || root.contains(event.target)) return;
        items.forEach(close);
      });
      // A pointer-opened menu may not own keyboard focus yet.
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !root.isConnected) return;
        const opened = items.find((item) => item.open);
        if (!opened) return;
        event.preventDefault();
        items.forEach(close);
        opened.querySelector('summary')?.focus();
      });
      addEventListener('resize', updateHeight, { passive: true });
      document.querySelector('.page-wrapper')?.addEventListener('scroll', updateHeight, { passive: true });
      // Theme-editor menu choices are reflected in the mobile drawer as well.
      document.querySelectorAll('[data-vics-mobile-group-links]').forEach((target) => {
        const source = root.querySelector(`[data-vics-navigation-group="${target.dataset.vicsMobileGroupLinks}"]`);
        if (source) target.replaceChildren(...[...source.querySelectorAll('a')].map((link) => link.cloneNode(true)));
      });
    });
  };
  window.vicsMegaNavigation = { initialise };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
